import cloneDeep from 'lodash.clonedeep';

import ScribeModel from 'js/models/ScribeModel';
import { ScribeScene, VSElementModel, VSImageShapeOrTextElementModel } from 'js/types';

export const getActiveScene = (scribe: ScribeModel): ScribeScene => {
  const activeScene = scribe.scenes.find(scene => scene.active);
  if (!activeScene) {
    return scribe.scenes[0];
  }
  return activeScene;
};

export const getActiveSceneIndex = (scribe: ScribeModel): number => {
  return scribe.scenes.findIndex(scene => scene.active);
};
export const getScenesById = (sceneIds: string[], scribe: ScribeModel): ScribeScene[] => {
  const toReturn: ScribeScene[] = [];
  scribe.scenes.forEach((scene: ScribeScene) => {
    if (sceneIds.includes(scene.id)) {
      toReturn.push(scene);
    }
  });

  if (toReturn.length === 0) {
    const activeScene = getActiveScene(scribe);

    if (!activeScene) {
      return toReturn;
    }

    toReturn.push(activeScene);
  }

  return toReturn;
};

const getSceneElements = (scribe: ScribeModel, elementIds: Array<string>): VSElementModel[] => {
  const elementsMap = new Map<string, VSElementModel>();
  scribe.elements.forEach(el => {
    if (!!el) {
      elementsMap.set(el.id, el);
    }
  });

  const elementsInScene: VSElementModel[] = [];

  elementIds.forEach(id => {
    const element = elementsMap.get(id);
    if (element) {
      elementsInScene.push(element);
    }
  });

  return elementsInScene;
};

export const mapSceneElementIdsToElements = (scribe: ScribeModel, scene: ScribeScene): VSElementModel[] => {
  if (!scene) {
    return [];
  }
  return getSceneElements(scribe, scene.elementIds);
};

export const mapActiveSceneElementIdsToElements = (scribe: ScribeModel) => {
  const scene = getActiveScene(scribe);
  if (!scene) {
    return undefined;
  }
  return mapSceneElementIdsToElements(scribe, scene);
};

export const getSceneSettings = (scene?: ScribeScene) => {
  if (!scene) {
    return undefined;
  }
  return cloneDeep(scene.settings);
};

export const getActiveSceneSettings = (scribe: ScribeModel) => {
  return getSceneSettings(getActiveScene(scribe));
};

export const getHidableElements = (scribe: ScribeModel) => {
  if (!scribe) return [];
  const activeScene = getActiveScene(scribe);
  if (!activeScene) return [];
  return activeScene.elementIds.reduce((acc, elementId) => {
    const element = scribe.elements.find(el => el.id === elementId);
    if (!element || element.type === 'Camera') return acc;
    return [...acc, element];
  }, [] as VSImageShapeOrTextElementModel[]);
};
